/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface TagReferenceExerciseDto
 */
export interface TagReferenceExerciseDto {

    /**
     * Exercise identifier
     *
     * @type {number}
     * @memberof TagReferenceExerciseDto
     */
    id: number;

    /**
     * @type {string}
     * @memberof TagReferenceExerciseDto
     * @example Mobilizzazione del collo
     */
    name: string;

    /**
     * The exercise, for linking
     *
     * @type {JoinEntityDto}
     * @memberof TagReferenceExerciseDto
     */
    exerciseRef: JoinEntityDto;
}
